import type { MetricCardsProps } from '../constants/vendor'
import '../styles/metric-cards.scss'

export function MetricCards({ metrics }: MetricCardsProps) {
  return (
    <section className="metric-grid metric-grid--vendor" aria-label="Key metrics">
      {metrics.map((metric) => (
        <article key={metric.id} className="metric-card">
          <p className="metric-card__label">{metric.label}</p>
          <div className="metric-card__row">
            <p className="metric-card__value">{metric.value}</p>
            <span className={`metric-card__hint metric-card__hint--${metric.hintTone}`}>
              {metric.hintTone === 'up' || metric.hintTone === 'down-good' ? (
                <span aria-hidden>{metric.hintTone === 'up' ? '↑ ' : '↓ '}</span>
              ) : null}
              {metric.hint}
            </span>
          </div>
        </article>
      ))}
    </section>
  )
}
